// DS2.1.1
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, {
  Props as BaseButtonProps,
} from '../PlainButtonOrLink';
import { Props as IconProps } from '../../Icons/IconWrap';
import { ButtonSize } from '../types';
import useIconSizeForButtonSize from '../hooks/useIconSizeForButtonSize';
import s from './BrandedButton.scss';

export interface Props extends BaseButtonProps {
  size: ButtonSize;
  icon?: React.ComponentType<IconProps>;
  postfixIcon?: React.ComponentType<IconProps>;
  variant:
    | 'brand-green'
    | 'core-orange'
    | 'dreamup-purple'
    | 'originals'
    | 'originals-angular'
    | 'originals-outline';
  children?: React.ReactNode;
}

const BrandedButton: React.FC<Props> = ({
  size,
  variant = 'brand-green',
  fillContainerWidth,
  className,
  children,
  icon: IconComponent,
  postfixIcon: PostFixIconComponent,
  loading,
  ...props
}) => {
  const iconSize = useIconSizeForButtonSize(size);
  return (
    <PlainButtonOrLink
      className={classnames(
        className,
        s['root'],
        s[`variant-${variant}`],
        s[`size-${size}`],
        fillContainerWidth && s['fill-container-width'],
        props.disabled && s['disabled'],
        loading && s['loading'],
        IconComponent && s['with-prefix-icon'],
        PostFixIconComponent && s['with-postfix-icon']
      )}
      {...props}
    >
      {IconComponent && (
        <IconComponent
          className={s['icon']}
          size={iconSize}
          disableDefaultColors
        />
      )}
      <span className={s['content']}>{children}</span>
      {PostFixIconComponent && (
        <PostFixIconComponent
          className={s['icon']}
          size={iconSize}
          disableDefaultColors
        />
      )}
    </PlainButtonOrLink>
  );
};
BrandedButton.displayName = 'BrandedButton';

export default BrandedButton;
